import * as o from "react";
import t from "../lib/IconBase.es.js";
import s from "../defs/FadersHorizontal.es.js";
const r = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...a, weights: s }));
r.displayName = "FadersHorizontalIcon";
const m = r;
export {
  m as FadersHorizontal,
  r as FadersHorizontalIcon
};
